import { useSelector, useDispatch } from 'react-redux';
import { selectPristine, selectIsPlaying, setIsPlaying } from '../app/reducers/successAnimation'
import VideoAnimation from './VideoAnimation'
import MastercardAnimation from './MastercardAnimation'
import { selectNextAction, setNextAction } from '../app/reducers/paymentMethod';

const NON_VIDEO_RENDERERS = {
  mastercard: (props) => <MastercardAnimation {...props} />
};

export default function SuccessAnimation(){
  const dispatch = useDispatch();
  const isPlaying = useSelector(selectIsPlaying);
  const pristine = useSelector(selectPristine);
  const nextAction = useSelector(selectNextAction);
  const onCompleteAnimation = ()=>{
    let payload={...nextAction};
    payload.animationCompleted=true;
    dispatch(setNextAction(payload));
    dispatch(setIsPlaying(false));
  };
  const animationKey = (nextAction && typeof nextAction.animation === 'string')
    ? nextAction.animation.toLowerCase()
    : null;
  const isNonVideo = Boolean(animationKey && NON_VIDEO_RENDERERS[animationKey]);
  const videoPath = (nextAction && typeof nextAction.animation_url === 'string' && nextAction.animation_url)
    ? nextAction.animation_url
    : null;
  const renderAnimation = (props) => {
    if (isNonVideo) {
      return NON_VIDEO_RENDERERS[animationKey](props);
    }
    if (!videoPath) {
      return null;
    }
    return <VideoAnimation {...props} key={videoPath} videoPath={videoPath} />;
  };
  return (
    <div className={"loading-overlay "+(pristine ? 'pristine' : '')+(isPlaying ? ' is-loading' : ' is-not-loading')}>
      {!pristine && isPlaying && renderAnimation({ onCompleteAnimation })}
    </div>
  );
}
